require("./brokerConvenienceTestCategories.scss");

const React = require("react");
const PropTypes = require("prop-types");
const classNames = require("classnames");
const BrokerConvenienceTestActionLink = require("../brokerConvenienceTestActionLink/brokerConvenienceTestActionLink");
const BrokerConvenienceTestSubCategories = require("../brokerConvenienceTestSubCategories/brokerConvenienceTestSubCategories");

class BrokerConvenienceTestCategories extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { immCategories, currentStepSubCategory, currentStepCategory } =
            this.props;
        const categoryTitleClassNames = (key) =>
            classNames("convenience-sidebar__category__title", {
                "convenience-sidebar__category__title--active":
                key <= currentStepCategory,
            });
        return (
            immCategories &&
            immCategories.map((immCategory, key) => {
                const iconClassName = key < currentStepCategory ?  'convenience-sidebar__category__title__icon icon-exito'  :`convenience-sidebar__category__title__icon ${immCategory.get('icon')}`
                
                return (
                    <div className="convenience-sidebar">
                        <ul className="convenience-sidebar__categories">
                            {" "}
                            <li
                                className="convenience-sidebar__category"
                                key={key}
                            >
                                <h2 className={categoryTitleClassNames(key)}>
                                    <BrokerConvenienceTestActionLink>
                                        <span className={iconClassName} />{" "}
                                        {immCategory.get("name")}
                                    </BrokerConvenienceTestActionLink>
                                </h2>
                                {immCategory.get(
                                    "subCategories",
                                    0,
                                    "name"
                                ) && (
                                    <BrokerConvenienceTestSubCategories
                                        category={key}
                                        currentStepCategory={currentStepCategory}
                                        activeItem={currentStepSubCategory}
                                        isActiveCategory={
                                            key <= currentStepCategory
                                        }
                                    >
                                        {immCategory.get("subCategories") &&
                                            immCategory
                                                .get("subCategories")
                                                .map((immSubCategory, key) => {
                                                    return !!immSubCategory.get(
                                                        "name"
                                                    ) ? (
                                                        <BrokerConvenienceTestActionLink>
                                                            {immSubCategory.get(
                                                                "name"
                                                            )}
                                                        </BrokerConvenienceTestActionLink>
                                                    ) : <div/>;
                                                })}
                                    </BrokerConvenienceTestSubCategories>
                                )}
                            </li>{" "}
                        </ul>
                    </div>
                );
            })
        );
    }
}

BrokerConvenienceTestCategories.propTypes = {
    immCategories: PropTypes.object.isRequired,
    currentStepSubCategory: PropTypes.number.isRequired,
    currentStepSubCategory: PropTypes.number.isRequired,
};

module.exports = BrokerConvenienceTestCategories;
